import { Fragment, type FC } from 'react';
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { Sync, Delete, MoreVert } from '@mui/icons-material';

export type AuditDetailsPageMenuProps = {
  onClose: () => void;
  onOpen: (event: HTMLElement) => void;

  isOpen: boolean;
  anchorEl: HTMLElement | null;

  onSynchronize: () => void;
  onDelete: () => void;
};

export const AuditDetailsPageMenu: FC<AuditDetailsPageMenuProps> = ({
  onClose,
  onOpen,

  isOpen,
  anchorEl,

  onSynchronize,
  onDelete,
}) => (
  <Fragment>
    <IconButton
      color="inherit"
      aria-label="more"
      aria-controls={isOpen ? 'Audit menu' : undefined}
      aria-expanded={isOpen ? 'true' : undefined}
      aria-haspopup="true"
      onClick={(e) => onOpen(e.currentTarget)}>
      <MoreVert />
    </IconButton>
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose}>
      <MenuItem onClick={onSynchronize}>
        <ListItemIcon>
          <Sync />
        </ListItemIcon>
        <ListItemText>Synchronize</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <Delete />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  </Fragment>
);
